import React from 'react';
import {classes, style} from './doppe-action-content-section-property-details.st.css';
import {cssEllipsis, flexRowAlignToCenter, Icon} from '@wix/devzai-utils-react';
import {DoppeActionContentSection} from '../../../client-server-common/types/doppe-action-content-section';
import {evaluateFunction} from '@wix/devzai-utils-common';
import {doppeHideableValueIsVisible} from '../../../client-server-common';
import {
    DoppePropertyBathroomsIcon,
    DoppePropertyBedroomsIcon,
    DoppePropertyClockIcon,
    DoppePropertyHomeAreaIcon,
    DoppePropertyHomeSizeIcon,
    DoppePropertyStairsIcon
} from '../../../doppe-static-assets/doppe-static-icons';
import {useDoppeViewerLocales} from '../../../client/doppe-viewer-locales/doppe-viewer-locales';


export const DoppeActionContentSectionPropertyDetails = React.memo(function DoppeActionContentSectionPropertyDetails(
    props: DoppeActionContentSectionPropertyDetails.Props
) {
    const {
        contentSection,
    } = props;

    const {
        landArea,
        houseArea,
        floors,
        bathroomsNumber,
        bedroomsNumber,
        yearBuilt,
    } = contentSection;

    const displayedItemsCount = evaluateFunction(() => {
        return (doppeHideableValueIsVisible(bedroomsNumber) ? 1 : 0) +
            (doppeHideableValueIsVisible(bathroomsNumber) ? 1 : 0) +
            (doppeHideableValueIsVisible(yearBuilt) ? 1 : 0) +
            (doppeHideableValueIsVisible(floors) ? 1 : 0) +
            (doppeHideableValueIsVisible(houseArea) ? 1 : 0) +
            (doppeHideableValueIsVisible(landArea) ? 1 : 0)
    })

    const doppeViewerLocales = useDoppeViewerLocales();

    return (
        <>
            {
                displayedItemsCount > 0 ?
                    <div
                        className={style(classes.root, {
                            isGrid: displayedItemsCount > 4
                        })}
                    >
                        {
                            doppeHideableValueIsVisible(bedroomsNumber) ?
                                <DoppeActionTypePropertyWidgetInnerDetailsSectionItem
                                    icon={DoppePropertyBedroomsIcon}
                                    title={doppeViewerLocales['propertyAction.details.bedrooms']({bedrooms: bedroomsNumber})}
                                />
                                :
                                null
                        }
                        {
                            doppeHideableValueIsVisible(bathroomsNumber) ?
                                <DoppeActionTypePropertyWidgetInnerDetailsSectionItem
                                    icon={DoppePropertyBathroomsIcon}
                                    title={doppeViewerLocales['propertyAction.details.bathrooms']({bathrooms: bathroomsNumber})}
                                />
                                :
                                null
                        }
                        {
                            doppeHideableValueIsVisible(houseArea) ?
                                <DoppeActionTypePropertyWidgetInnerDetailsSectionItem
                                    icon={DoppePropertyHomeSizeIcon}
                                    title={houseArea}
                                />
                                :
                                null
                        }
                        {
                            doppeHideableValueIsVisible(landArea) ?
                                <DoppeActionTypePropertyWidgetInnerDetailsSectionItem
                                    icon={DoppePropertyHomeAreaIcon}
                                    title={landArea}
                                />
                                :
                                null
                        }
                        {
                            doppeHideableValueIsVisible(floors) ?
                                <DoppeActionTypePropertyWidgetInnerDetailsSectionItem
                                    icon={DoppePropertyStairsIcon}
                                    title={doppeViewerLocales['propertyAction.details.floors']({floors: floors})}
                                />
                                :
                                null
                        }
                        {
                            doppeHideableValueIsVisible(yearBuilt) ?
                                <DoppeActionTypePropertyWidgetInnerDetailsSectionItem
                                    icon={DoppePropertyClockIcon}
                                    title={doppeViewerLocales["propertyAction.details.yearBuilt"]({yearBuilt: yearBuilt})}
                                />
                                :
                                null
                        }
                    </div>
                    :
                    null
            }
        </>
    );
});

const DoppeActionTypePropertyWidgetInnerDetailsSectionItem = React.memo(function DoppeActionTypePropertyWidgetInnerDetailsSectionItem(
    props: {
        icon: Icon.Src,
        title: string,
    }
) {
    const {
        title,
        icon
    } = props;

    return (
        <div
            className={style(classes.detailsItem, {}, flexRowAlignToCenter())}
        >
            <Icon
                className={style(classes.detailsItemIcon, {})}
                icon={icon}
            />
            <div
                className={style(classes.detailsText, {}, cssEllipsis())}
            >
                {title}
            </div>
        </div>
    );
});

export namespace DoppeActionContentSectionPropertyDetails {

    export interface Props extends React.HTMLAttributes<any> {
        contentSection: DoppeActionContentSection.PropertyDetailsSettings;
    }
}
